// Textos de la revisión de los viajes de empresa de Taxi / VTC: bandeja de la
// empresa, detalle, rechazo y ajustes globales de WAIIS. Se registran junto al
// resto de vocabularios en AppComponent.
export const locale = {
  lang: 'en',
  data: {
    RIDE_REVIEWS: {
      TITLE: 'Smart ride review',
      RETRY: 'Retry',
      LOAD_ERROR: 'The rides to review could not be loaded.',
      KPIS_ERROR: 'The indicators could not be loaded.',
      BADGE: {
        RED: 'Review required',
        ORANGE: 'Review recommended',
        YELLOW: 'Approved · low suspicion',
        GREEN: 'Automatically approved',
        APPROVED: 'Approved by the company',
        REJECTED: 'Rejected by the company',
      },
      KPI: {
        ANALYZED: 'Rides analysed · 30 days',
        ANALYZED_HINT: 'All rides paid by the company',
        AUTO: 'Approved without intervention',
        AUTO_HINT: '{{count}} with low suspicion, logged',
        AUTO_HINT_ONE: '1 with low suspicion, logged',
        PENDING: 'Need your decision',
        PENDING_HINT: '{{count}} required',
        PENDING_HINT_ONE: '1 required',
        NOTHING_PENDING: 'Nothing pending',
      },
      FILTER: {
        ARIA: 'Which rides to show',
        PENDING: 'Pending',
        RED: 'Required',
        ORANGE: 'Recommended',
        YELLOW: 'Low suspicion',
        RESOLVED: 'Resolved',
      },
      HOW: {
        TITLE: 'How it works',
        GREEN: 'Matches the usual schedule, origin, destination and cost. You do not see it.',
        YELLOW: 'A minor deviation. It is approved and logged.',
        ORANGE: 'Several unusual signals. Worth a look.',
        RED: 'Outside the policy or possibly personal. You decide.',
        GREEN_TITLE: 'Automatically approved',
        YELLOW_TITLE: 'Low suspicion',
        NOTE: 'For this to work, the app asks the employee for a reason on every company-paid ride and for a justification when the ride does not fit their pattern.',
      },
      CARD: {
        REASON: 'Stated reason',
        JUSTIFICATION: 'Justification',
        NO_JUSTIFICATION: 'Not provided',
        PAID_BY_COMPANY: 'Paid by the company',
        PLUS_EMPLOYEE: '+ {{amount}} employee',
        POINTS: '{{count}} pts',
        POINTS_ONE: '1 pt',
        APPROVE: 'Approve',
        REJECT: 'Reject',
        DETAIL: 'View details',
        NO_REASON: 'No reason',
      },
      EMPTY: {
        PENDING_TITLE: 'Nothing to review',
        PENDING: 'All company-paid rides match each employee’s pattern.',
        OTHER_TITLE: 'No rides here',
      },
      MORE: 'Show more',
      SHOWING: 'Showing {{shown}} of {{total}} rides',
      SHOWING_ONE: 'Showing {{shown}} of 1 ride',
      APPROVED_OK: 'Ride of {{name}} approved',
      APPROVE_ERROR: 'The ride could not be approved',
      REJECTED_OK: 'Ride rejected: the amount will be claimed back from the employee, who will be notified',
      REJECT_ERROR: 'The ride could not be rejected',
      ALREADY_DECIDED: 'This ride already has a decision',
      ACCEPT: 'OK',
      DETAIL: {
        CLOSE: 'Close',
        LOAD_ERROR: 'The ride could not be loaded.',
        SIGNALS: 'Signals',
        HARD_RULES: 'Rules that require a review',
        SCORE: 'Score',
        SCORE_VALUE: '{{count}} points',
        SCORE_VALUE_ONE: '1 point',
        PRODUCT: 'Service',
        REVIEW: 'Review',
        DECISION: 'Decision',
        DECIDED_BY: '{{name}} · {{date}}',
        REJECT_REASON: 'Rejection reason',
        REJECT_MESSAGE: 'Message to the employee',
        PAYMENT: 'Payment split',
        COMPANY: 'Company',
        EMPLOYEE: 'Employee’s card',
        NO_AMOUNT: 'No amount yet',
      },
      REJECT: {
        TITLE: 'Reject ride',
        INTRO: 'You are about to reject the ride of {{name}} · {{route}}. What the company paid will be claimed back from the employee, who will be notified.',
        REASON: 'Reason',
        REASON_HINT: 'Sent to the employee',
        REASON_REQUIRED: 'Choose a reason.',
        MESSAGE: 'Message to the employee',
        MESSAGE_PLACEHOLDER: 'Message to the employee (optional)…',
        CANCEL: 'Cancel',
        SUBMIT: 'Reject and notify',
        SUBMITTING: 'Rejecting…',
      },
      REASON: {
        personal_trip: 'Personal ride, not for work',
        carpooling_available: 'Carpooling was available',
        outside_policy_schedule: 'Outside the policy schedule',
        missing_justification: 'Missing justification',
        unauthorized_cost: 'Unauthorised cost',
      },
      SIGNAL: {
        weekend: 'Weekend ride',
        night: 'Late-night ride',
        unrelated_origin: 'Origin not related to an office, a station or a known place',
        unrelated_destination: 'Destination not related to an office, a station or a known place',
        cost_above_average: 'Cost above the employee’s average',
        duplicate: 'Possible duplicate of an almost identical ride',
        excessive_use: 'More company rides than allowed this week',
        missing_justification: 'No justification on an unusual ride',
      },
      HARD_RULE: {
        unrelated_destination_without_justification: 'Unrelated destination without justification',
        off_hours_unrelated_trip: 'Weekend or late night with unrelated origin and destination',
        duplicate: 'Possible duplicate ride',
        cost_double_without_justification: 'Cost twice the average or more without justification',
      },
      SETTINGS: {
        NOTE_TITLE: 'They apply to every company',
        NOTE_TEXT: 'Changes only affect rides scored from now on: rides already reviewed keep their points.',
        LOAD_ERROR: 'The review settings could not be loaded.',
        SAVE: 'Save changes',
        SAVING: 'Saving…',
        SAVED: 'Review settings saved',
        SAVE_ERROR: 'The settings could not be saved',
        REQUIRED: 'Required.',
        POINTS_TITLE: 'Points per signal',
        POINTS_SUB: 'What each signal adds when it fires.',
        POINT: {
          weekend: 'Weekend',
          night: 'Late night',
          unrelatedOrigin: 'Unrelated origin',
          unrelatedDestination: 'Unrelated destination',
          duplicate: 'Duplicate',
          excessiveUse: 'Excessive use',
          missingJustification: 'No justification',
        },
        LEVELS_TITLE: 'Levels',
        LEVELS_SUB: 'Points from which a ride moves to each level. Orange and red wait for the company.',
        LEVEL_YELLOW: 'Low suspicion from',
        LEVEL_ORANGE: 'Review recommended from',
        LEVEL_RED: 'Review required from',
        COST_TITLE: 'Cost',
        COST_SUB: 'Compared with the average of the employee’s other company rides.',
        COST_STEP: 'Step {{n}}',
        COST_STEP_PCT: '% above average',
        COST_STEP_POINTS: 'Points',
        COST_HARD_RULE: '% above average that requires a review without justification',
        COST_HISTORY_DAYS: 'Days of history',
        COST_MIN_RIDES: 'Minimum rides to work out the average',
        SCHEDULE_TITLE: 'Schedule and use',
        SCHEDULE_SUB: 'Late night and number of rides per week.',
        NIGHT_END_HOUR: 'Late night ends at (hour)',
        MAX_WEEKLY_RIDES: 'Rides allowed per week',
        DISTANCES_TITLE: 'Distances',
        DISTANCES_SUB: 'When a point is near a related place and when two rides are the same.',
        PLACE_RADIUS: 'Radius of a related place (m)',
        DUPLICATE_RADIUS: 'Radius of a duplicate ride (m)',
        DUPLICATE_MINUTES: 'Minutes between duplicate rides',
        STATIONS_TITLE: 'Stations',
        STATIONS_SUB: 'Which stops count as a related place. With none ticked, none counts.',
        STATION: {
          bus_stop: 'Bus stops',
          train_station: 'Train stations',
          metro_station: 'Metro stations',
        },
        PLACES_TITLE: 'Known places',
        PLACES_SUB: 'Besides offices and stations, for every company.',
        PLACE_NAME: 'Name',
        PLACE_LAT: 'Latitude',
        PLACE_LNG: 'Longitude',
        PLACE_ADD: 'Add place',
        PLACE_REMOVE: 'Remove {{name}}',
        PLACES_EMPTY: 'No known places.',
      },
    },
  },
};
